<div class="h-screen flex flex-col justify-center items-center">
    <ng-lottie [options]="options"></ng-lottie>
    <p class="text-2xl sm:text-5xl font-semibold text-[#009D90]">
        Página não foi encontrada
    </p>
</div>